import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MapaDireccionComponent } from '../map/map.component';
import { S3UploadService, UploadedImage } from '../../services/uploadImages';
import { environment } from '../../../enviroment/enviroment';
import { HostingService } from '../../services/hosting.service';
import { SuperAdminNavbarComponent } from '../../components/superadmin-navbar/superadmin-navbar.component';
import { AuthService } from '../../services/auth.service';
import { AdminHotelNavbarComponent } from '../../components/admin-hotel-navbar/admin-hotel-navbar.component';
import { NavbarComponent } from "../../components/navbar/navbar.component";

@Component({
  selector: 'app-superadmin-create-hosting',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MapaDireccionComponent,
    SuperAdminNavbarComponent,
    AdminHotelNavbarComponent,
    NavbarComponent
],
  templateUrl: './superadmin-create-hosting.component.html',
  styleUrls: ['./superadmin-create-hosting.component.css']
})

export class SuperAdminCreateHostingComponent implements OnInit {
  @Input() modoAdminHotel: boolean = false;
  @ViewChild('container') containerRef!: ElementRef;

  // Estado de carga
  isLoading = false;
  loadingMessage = 'Procesando...';

  // Método temporal para refrescar el token manualmente
  async refrescarTokenManual() {
    try {
      await this.authService.refreshToken();
      alert('Token refrescado correctamente');
    } catch (e: any) {
      alert('Error al refrescar token: ' + (e?.message || e));
    }
  }

  // Reviews de huéspedes
  reviews: Array<{
    rating: number;
    created_at: string;
    comment: string;
    guest: string;
  }> = [];
  nuevoReview = {
    rating: 5,
    created_at: '',
    comment: '',
    guest: ''
  };

  agregarReview() {
    if (!this.nuevoReview.guest || !this.nuevoReview.comment || !this.nuevoReview.rating) return;
    const review = {
      ...this.nuevoReview,
      created_at: this.nuevoReview.created_at || new Date().toISOString()
    };
    this.reviews.push(review);
    this.nuevoReview = {
      rating: 5,
      created_at: '',
      comment: '',
      guest: ''
    };
  }

  eliminarReview(idx: number) {
    this.reviews.splice(idx, 1);
  }
  // Reglas del alojamiento
  reglas: Array<{
    rule_id: string;
    penalty: string;
    description: string;
    title: string;
    category: string;
    status: string;
    created_at: string;
    updated_at: string;
  }> = [];
  nuevaRegla = {
    rule_id: '',
    penalty: '',
    description: '',
    title: '',
    category: '',
    status: 'active',
    created_at: '',
    updated_at: ''
  };

  agregarRegla() {
    if (!this.nuevaRegla.title || !this.nuevaRegla.description) return;
    const now = new Date().toISOString();
    const regla = {
      ...this.nuevaRegla,
      rule_id: `rule-${this.nuevaRegla.title.replace(/\s+/g, '-').toLowerCase()}`,
      created_at: now,
      updated_at: now
    };
    this.reglas.push(regla);
    this.nuevaRegla = {
      rule_id: '',
      penalty: '',
      description: '',
      title: '',
      category: '',
      status: 'active',
      created_at: '',
      updated_at: ''
    };
  }

  eliminarRegla(idx: number) {
    this.reglas.splice(idx, 1);
  }
  // Métodos de pago disponibles
  metodosPagoDisponibles: string[] = [
    'Efectivo',
    'Tarjeta de crédito/débito',
    'PSE',
    'PayPal',
    'Nequi',
    'Efecty',
    'Bancolombia',
    'Daviplata',
    'Transferencia bancaria'
  ];
  metodosPagoSeleccionados: string[] = [];
  metodoPagoTemp: string = '';

  agregarMetodoPago(metodo: string) {
    if (metodo && !this.metodosPagoSeleccionados.includes(metodo)) {
      this.metodosPagoSeleccionados.push(metodo);
    }
  }
  // Validar que al menos un método de pago esté seleccionado
  validarMetodosPago(): boolean {
    return this.metodosPagoSeleccionados.length > 0;
  }

  eliminarMetodoPago(idx: number) {
    this.metodosPagoSeleccionados.splice(idx, 1);
  }
  // Servicio principal (faltaba la propiedad)
  servicioData = {
    name: [] as string[],
    accessibility: 'Instalaciones adaptadas para personas con movilidad reducida',
    service_id: ''
  };

  tiposAlojamiento = [
    { nombre: 'Cabaña' },
    { nombre: 'Resort' },
    { nombre: 'Eco Lodge' },
    { nombre: 'Hotel' },
  ];

  tiposDocumento = [
    { nombre: 'Cédula de Ciudadanía' },
    { nombre: 'Cédula de Extranjería' },
    { nombre: 'Pasaporte' },
    { nombre: 'Tarjeta de Identidad' },
  ];

  datoBasicos = {
    id: '',
    name: '',
    email: '',
    phone: '',
    description: '',
    capacity: '',
    type: '',
    rooms: ''
  };

  anfitrion = {
    name: '',
    documentType: '',
    documentNumber: '',
    lastName: '',
    email: '',
    phone: '',
    anfitrion_id: ''
  };


  // Coordenadas iniciales (Bogotá por defecto)
  coordenadasSeleccionadas = {
    lat: 4.7110,
    lng: -74.0721
  };

  // Datos de ubicación
  ubicacionData = {
    direccion: '',
    ubicacion: '',
    latitud: '',
    longitud: '',
    ciudad: '',
    pais: '',
    area: '',
    location_id: ''
  };

  serviciosAdicionalesExtras: any[] = [];

  // Servicios adicionales incluidos (sin costo)
  serviciosAdicionalesIncluidos: { service: string }[] = [];


  // Habitaciones
  habitaciones: any[] = [];
  nuevaHabitacion: any = {
    room_id: '',
    number: '',
    images: [],
    price_per_night: '',
    type: '',
    floor: '',
    beds: '',
    bathroom: ''
  };
  imagenesHabitacion: any[] = [];
  imagenesHabitacionPreview: string[] = [];
  imagenesHabitacionCargando: boolean = false;
  imagenesHabitacionError: string = '';

  isEditMode = false;
  hostingIdToEdit: string | null = null;

  adminHotelEmail: string = '';

  constructor(
    private readonly hostingService: HostingService,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly authService: AuthService, // <--- inyectar AuthService
    private readonly s3UploadService: S3UploadService
  ) { }

  async onHabitacionFilesSelected(event: any): Promise<void> {
    const input = event.target as HTMLInputElement;
    const files = input?.files;
    if (!files || files.length === 0) return;
    this.imagenesHabitacionError = '';
    this.imagenesHabitacionCargando = true;

    // Limpia arrays solo si es una nueva carga completa
    this.imagenesHabitacion = [];
    this.imagenesHabitacionPreview = [];
    try {
      for (const file of Array.from(files)) {
        const validation = this.s3UploadService.validateImage(file);
        if (!validation.valid) {
          this.imagenesHabitacionError = validation.error || 'Archivo no válido';
          continue;
        }
        try {
          const preview = await this.s3UploadService.generatePreview(file);
          if (preview) this.imagenesHabitacionPreview.push(preview);

          const uploadResp = await this.s3UploadService.uploadImageToS3(file, 'room');
          if (uploadResp?.success && uploadResp?.url) {
            this.imagenesHabitacion.push(uploadResp.url);
          } else {
            this.imagenesHabitacionError = uploadResp?.error || 'Error subiendo imagen';
          }
        } catch (innerErr) {
          console.error('Error procesando imagen individual:', innerErr);
          this.imagenesHabitacionError = 'Error al procesar una de las imágenes';
        }
      }
    } catch (err) {
      console.error('Error general al procesar imágenes:', err);
      this.imagenesHabitacionError = 'Error procesando imágenes';
    } finally {
      this.imagenesHabitacionCargando = false;
      // 🔥 Limpia el input para que (change) se dispare incluso si seleccionas la misma imagen
      input.value = '';
    }
  }

  agregarHabitacion() {
    if (!this.nuevaHabitacion.number || !this.nuevaHabitacion.type || !this.nuevaHabitacion.price_per_night) {
      return;
    }
    const habitacion = {
      ...this.nuevaHabitacion,
      room_id: `room-${this.nuevaHabitacion.type.replace(/\s+/g, '-').toLowerCase()}-${this.nuevaHabitacion.number}`,
      images: [...this.imagenesHabitacion],
      number: Number(this.nuevaHabitacion.number),
      price_per_night: Number(this.nuevaHabitacion.price_per_night),
      floor: Number(this.nuevaHabitacion.floor),
      beds: Number(this.nuevaHabitacion.beds),
      bathroom: Number(this.nuevaHabitacion.bathroom)
    };
    this.habitaciones.push(habitacion);
    this.nuevaHabitacion = {
      room_id: '',
      number: '',
      images: [],
      price_per_night: '',
      type: '',
      floor: '',
      beds: '',
      bathroom: ''
    };
  }

  // Ayuda contextual
  ayudaVisible = {
    mapa: false
  };

  imagenesAlojamiento: UploadedImage[] = [];
  imagenPrincipalIndex: number = -1;
  isDragOver: boolean = false;

  uploadProgress = {
    show: false,
    percentage: 0,
    uploaded: 0,
    total: 0
  };

  // ...existing code...

  ngOnInit(): void {
    // Leer modoAdminHotel desde data de la ruta si existe
    const modoAdminHotelRuta = this.route.snapshot.data['modoAdminHotel'];
    if (typeof modoAdminHotelRuta === 'boolean') {
      this.modoAdminHotel = modoAdminHotelRuta;
    }
    this.route.paramMap.subscribe(async params => {
      const id = params.get('id');
      if (id) {
        this.isEditMode = true;
        this.hostingIdToEdit = id;
        // Cargar datos del alojamiento y poblar el formulario
        try {
          const hosting = await this.hostingService.getHosting(id).toPromise();
          this.poblarFormularioDesdeHosting(hosting);
        } catch (e) {
          alert('No se pudo cargar el alojamiento para editar.');
          this.router.navigate(['/allhostings']);
        }
      }
    });
    console.log('Componente de mapa y ubicación inicializado');
  }

  poblarFormularioDesdeHosting(hosting: any) {
    // Poblar los datos básicos
    this.datoBasicos = {
      id: hosting.id,
      name: hosting.name,
      email: hosting.email,
      phone: hosting.phone,
      description: hosting.description,
      capacity: hosting.ability,
      type: hosting.type,
      rooms: hosting.rooms
    };
    // Poblar anfitrión
    this.anfitrion = {
      name: hosting.amphitryon?.name || '',
      lastName: hosting.amphitryon?.lastname || '',
      email: hosting.amphitryon?.email || '',
      phone: '',
      documentType: '',
      documentNumber: '',
      anfitrion_id: hosting.amphitryon?.amphitryon_id || ''
    };
    // Poblar ubicación
    this.ubicacionData = {
      direccion: hosting.location?.adress || '',
      ubicacion: '',
      latitud: hosting.location?.latitude || '',
      longitud: hosting.location?.longitude || '',
      ciudad: hosting.location?.city || '',
      pais: hosting.location?.country || '',
      area: hosting.location?.area || '',
      location_id: hosting.location?.location_id || ''
    };
    // Poblar métodos de pago
    this.metodosPagoSeleccionados = hosting.payment_method || [];
    // Poblar servicios principales
    this.servicioData = {
      name: hosting.service?.name || [],
      accessibility: hosting.service?.accessibility || '',
      service_id: hosting.service?.service_id || ''
    };
    // Poblar servicios adicionales
    this.serviciosAdicionalesExtras = hosting.additional || [];
    // Poblar habitaciones (solo una por compatibilidad actual)
    this.habitaciones = hosting.room ? [hosting.room] : [];
    // Poblar reglas
    this.reglas = hosting.rule ? [hosting.rule] : [];
    // Poblar reviews
    this.reviews = hosting.review?.reviews?.map((r: any) => ({
      rating: r.rating,
      created_at: r.created_at,
      comment: r.comment,
      guest: ''
    })) || [];
    // Poblar imágenes (solo URLs)
    this.imagenesAlojamiento = (hosting.images || []).map((url: string, idx: number) => ({
      url,
      file: { name: `img-${idx}`, size: 0, type: '', lastModified: 0 },
      uploaded: true,
      key: '',
    }));
    this.imagenPrincipalIndex = 0;
  }

  // Manejar coordenadas seleccionadas en el mapa
  onCoordenadasSeleccionadas(coordenadas: { lat: number, lng: number }): void {
    this.coordenadasSeleccionadas = coordenadas;
    this.ubicacionData.latitud = coordenadas.lat.toString();
    this.ubicacionData.longitud = coordenadas.lng.toString();
    this.ubicacionData.ubicacion = `${coordenadas.lat}, ${coordenadas.lng}`;

    console.log('Coordenadas seleccionadas:', coordenadas);
    this.obtenerDireccionPorCoordenadas(coordenadas.lat, coordenadas.lng);
  }

  // Obtener dirección a partir de coordenadas
  async obtenerDireccionPorCoordenadas(lat: number, lng: number): Promise<void> {
    try {
      const url = `${environment.openStreetMapUrl}&lat=${lat}&lon=${lng}&addressdetails=1&accept-language=es`;
      const response = await fetch(url);

      if (!response.ok) {
        throw new Error(`Error en geocodificación: ${response.status}`);
      }

      const data = await response.json();

      if (data && data.address) {
        const address = data.address;

        this.ubicacionData.direccion = this.construirDireccionCompleta(data);
        this.ubicacionData.ciudad = address.city || address.town || address.municipality || '';
        this.ubicacionData.pais = address.country || '';
        this.ubicacionData.area = address.state || address.county || '';
        console.log('Dirección obtenida:', this.ubicacionData.direccion);
      } else {
        this.ubicacionData.direccion = `Coordenadas: ${lat.toFixed(6)}, ${lng.toFixed(6)}`;
      }
    } catch (error) {
      console.error('Error en geocodificación inversa:', error);
      this.ubicacionData.direccion = `Coordenadas: ${lat.toFixed(6)}, ${lng.toFixed(6)}`;
    }
  }

  // Construir dirección completa
  private construirDireccionCompleta(data: any): string {
    const address = data.address;
    const parts: string[] = [];

    if (address.road) parts.push(address.road);
    if (address.house_number) {
      if (parts.length > 0) {
        parts[parts.length - 1] += ` #${address.house_number}`;
      } else {
        parts.push(`#${address.house_number}`);
      }
    }
    if (address.neighbourhood || address.suburb || address.quarter) {
      const barrio = address.neighbourhood || address.suburb || address.quarter;
      parts.push(barrio);
    }
    if (address.city || address.town || address.municipality) {
      const ciudad = address.city || address.town || address.municipality;
      parts.push(ciudad);
    }
    if (address.state) parts.push(address.state);

    return parts.join(', ') || data.display_name || 'Dirección no disponible';
  }

  // Aplicar coordenadas manuales
  aplicarLatLngEnMapa() {
    if (!this.ubicacionData.latitud || !this.ubicacionData.longitud) {
      alert('Por favor completa ambos campos: Latitud y Longitud.');
      return;
    }
    const lat = parseFloat(this.ubicacionData.latitud);
    const lng = parseFloat(this.ubicacionData.longitud);
    if (isNaN(lat)) {
      alert('La latitud debe ser un número válido.');
      return;
    }
    if (isNaN(lng)) {
      alert('La longitud debe ser un número válido.');
      return;
    }
    if (lat < -90 || lat > 90) {
      alert('La latitud debe estar entre -90 y 90.');
      return;
    }
    if (lng < -180 || lng > 180) {
      alert('La longitud debe estar entre -180 y 180.');
      return;
    }
    this.coordenadasSeleccionadas = { lat, lng };
    this.ubicacionData.ubicacion = `${lat}, ${lng}`;
    this.obtenerDireccionPorCoordenadas(lat, lng);
  }

  // Obtener ubicación por GPS
  obtenerUbicacionGPS(): void {
    if (!navigator.geolocation) {
      alert('Tu navegador no soporta geolocalización');
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const coords = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
        this.onCoordenadasSeleccionadas(coords);
      },
      (error) => {
        console.error('Error obteniendo ubicación GPS:', error);
        alert('No se pudo obtener la ubicación GPS. Asegúrate de haber dado los permisos necesarios.');
      }
    );
  }

  // Métodos para ayuda contextual
  toggleAyuda(tipo: string): void {
    this.ayudaVisible[tipo as keyof typeof this.ayudaVisible] = !this.ayudaVisible[tipo as keyof typeof this.ayudaVisible];
  }
  cerrarTodasLasAyudas(): void {
    this.ayudaVisible = { mapa: false };
  }

  // ===== MÉTODOS PARA SERVICIOS ADICIONALES EXTRAS =====

  // Agregar servicio adicional extra
  agregarServicioExtra(): void {
    this.serviciosAdicionalesExtras.push({
      cost: 0,
      additional_id: this.generarAdditionalId(),
      service: '',
      status: 'activo'
    });
  }

  // Eliminar servicio adicional extra
  eliminarServicioExtra(index: number): void {
    this.serviciosAdicionalesExtras.splice(index, 1);
  }

  // ===== MÉTODOS PARA SERVICIOS ADICIONALES INCLUIDOS =====

  // Agregar servicio incluido
  agregarServicioIncluido(): void {
    this.serviciosAdicionalesIncluidos.push({ service: '' });
  }

  // Eliminar servicio incluido
  eliminarServicioIncluido(index: number): void {
    this.serviciosAdicionalesIncluidos.splice(index, 1);
  }

  // ===== MÉTODOS PARA SERVICIOS PRINCIPALES =====

  // Agregar servicio principal
  agregarServicioPrincipal(): void {
    this.servicioData.name.push('');
  }

  // Eliminar servicio principal
  eliminarServicioPrincipal(index: number): void {
    this.servicioData.name.splice(index, 1);
  }

  // ===== GENERADORES DE IDs =====

  // Generar ID para servicio adicional
  private generarAdditionalId(): string {
    const timestamp = Date.now();
    return `add-${timestamp}`;
  }

  // Generar ID para servicio principal
  private generarServiceId(): void {
    if (!this.servicioData.service_id) {
      const timestamp = Date.now();
      this.servicioData.service_id = `srv-${timestamp}`;
    }
  }

  // Metodos auxiliares ubicacion
  generarLocationId(): void {
    const ciudad = this.ubicacionData.ciudad.toLowerCase().replace(/\s+/g, '-');
    const date = Date.now();
    this.ubicacionData.location_id = `loc-${ciudad}-${date}`;
  }
  generarAnfitrionId(): void {
    const name = this.anfitrion.name.toLowerCase().replace(/\s+/g, '-');
    const lastname = this.anfitrion.lastName.toLowerCase().replace(/\s+/g, '-');
    const date = Date.now();
    this.anfitrion.anfitrion_id = `amp-${name}-${lastname}-${date}`;
  }
  validarUbicacion(): boolean {
    return !!(
      this.ubicacionData.ciudad &&
      this.ubicacionData.pais &&
      this.ubicacionData.latitud &&
      this.ubicacionData.longitud
    );
  }
  validarAnfitrion(): boolean {
    return !!(
      this.anfitrion.name &&
      this.anfitrion.lastName &&
      this.anfitrion.email
    );
  }

  validarHabitacion(): boolean {
    // Al menos una habitación con número, tipo y precio válido
    return this.habitaciones.length > 0 && this.habitaciones.every(hab =>
      hab.number && hab.type && hab.price_per_night && hab.images && hab.images.length > 0
    );
  }


  // NUEVOS MÉTODOS PARA MANEJO DE IMÁGENES

  /**
   * Maneja la selección de archivos desde el input
   */
  async onFilesSelected(event: Event): Promise<void> {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const files = Array.from(input.files);
      await this.procesarImagenes(files);
      // Limpiar el input para permitir seleccionar el mismo archivo de nuevo
      input.value = '';
    }
  }

  /**
   * Maneja el evento de arrastrar archivos sobre el área
   */
  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = true;
  }

  /**
   * Maneja cuando se sale del área de arrastre
   */
  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;
  }

  /**
   * Maneja cuando se sueltan archivos en el área
   */
  async onFilesDrop(event: DragEvent): Promise<void> {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;

    if (event.dataTransfer?.files) {
      const files = Array.from(event.dataTransfer.files);
      // Filtrar solo archivos de imagen
      const imageFiles = files.filter(file => file.type.startsWith('image/'));

      if (imageFiles.length !== files.length) {
        alert('Solo se pueden subir archivos de imagen');
      }

      if (imageFiles.length > 0) {
        await this.procesarImagenes(imageFiles);
      }
    }
  }

  /**
   * Procesa las imágenes seleccionadas
   */
  private async procesarImagenes(files: File[]): Promise<void> {
    // Validar número máximo de imágenes (por ejemplo, 10)
    const maxImages = 10;
    const totalImages = this.imagenesAlojamiento.length + files.length;

    if (totalImages > maxImages) {
      alert(`Solo puedes subir un máximo de ${maxImages} imágenes. Tienes ${this.imagenesAlojamiento.length} y estás intentando agregar ${files.length}.`);
      return;
    }

    // Mostrar progreso
    this.uploadProgress = {
      show: true,
      percentage: 0,
      uploaded: 0,
      total: files.length
    };

    try {
      // Generar ID único para este alojamiento (si no existe)
      const alojamientoId = this.generarAlojamientoId();

      // Subir imágenes
      const uploadedImages = await this.s3UploadService.uploadMultipleImages(
        files,
        alojamientoId,
        (progress, uploadedCount) => {
          this.uploadProgress.percentage = Math.round(progress);
          this.uploadProgress.uploaded = uploadedCount;
        }
      );

      // Agregar a la lista
      this.imagenesAlojamiento.push(...uploadedImages);

      // Si es la primera imagen, marcarla como principal
      if (this.imagenPrincipalIndex === -1 && uploadedImages.some(img => img.uploaded)) {
        const firstUploadedIndex = this.imagenesAlojamiento.findIndex(img => img.uploaded);
        if (firstUploadedIndex !== -1) {
          this.imagenPrincipalIndex = firstUploadedIndex;
        }
      }

      // Ocultar progreso después de un momento
      setTimeout(() => {
        this.uploadProgress.show = false;
      }, 1500);

      console.log('Imágenes procesadas:', this.imagenesAlojamiento);

    } catch (error) {
      console.error('Error procesando imágenes:', error);
      alert('Error al procesar las imágenes');
      this.uploadProgress.show = false;
    }
  }

  /**
   * Marca una imagen como principal
   */
  marcarComoPrincipal(index: number): void {
    if (this.imagenesAlojamiento[index]?.uploaded) {
      this.imagenPrincipalIndex = index;
    }
  }

  /**
   * Elimina una imagen
   */
  async eliminarImagen(index: number): Promise<void> {
    const imagen = this.imagenesAlojamiento[index];

    if (!imagen) return;

    // Confirmar eliminación
    if (!confirm('¿Estás seguro de que quieres eliminar esta imagen?')) {
      return;
    }

    try {
      // Si la imagen fue subida a S3, eliminarla
      if (imagen.uploaded && imagen.key) {
        const deleted = await this.s3UploadService.deleteImageFromS3(imagen.key);
        if (!deleted) {
          console.warn('No se pudo eliminar la imagen de S3');
        }
      }

      // Eliminar de la lista local
      this.imagenesAlojamiento.splice(index, 1);

      // Reajustar el índice de imagen principal
      if (this.imagenPrincipalIndex === index) {
        // Si eliminamos la imagen principal, seleccionar la primera disponible
        this.imagenPrincipalIndex = this.imagenesAlojamiento.findIndex(img => img.uploaded);
        if (this.imagenPrincipalIndex === -1) {
          this.imagenPrincipalIndex = -1;
        }
      } else if (this.imagenPrincipalIndex > index) {
        // Si eliminamos una imagen antes de la principal, ajustar el índice
        this.imagenPrincipalIndex--;
      }

    } catch (error) {
      console.error('Error eliminando imagen:', error);
      alert('Error al eliminar la imagen');
    }
  }

  /**
   * Formatea el tamaño del archivo
   */
  formatFileSize(bytes: number): string {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }

  /**
   * Genera un ID único para el alojamiento
   */
  private generarAlojamientoId(): string {
    const name = this.datoBasicos.name.toLowerCase().replace(/\s+/g, '-') || 'alojamiento';
    const timestamp = Date.now();
    return `${name}-${timestamp}`;
  }

  /**
   * Obtiene solo las imágenes que fueron subidas exitosamente
   */
  get imagenesSubidas(): UploadedImage[] {
    return this.imagenesAlojamiento.filter(img => img.uploaded);
  }

  /**
   * Valida que haya al menos una imagen subida
   */
  validarImagenes(): boolean {
    return this.imagenesSubidas.length > 0;
  }


  // Get por ahora para que no de error
  //const locationData = {
  get locationData() {
    return {
      area: this.ubicacionData.area,
      country: this.ubicacionData.pais,
      address: this.ubicacionData.direccion,
      city: this.ubicacionData.ciudad,
      latitude: parseFloat(this.ubicacionData.latitud),
      longitude: parseFloat(this.ubicacionData.longitud),
      location_id: this.ubicacionData.location_id
    };
  }

  get amphitryonData() {
    return {
      amphitryon_id: String(this.anfitrion.anfitrion_id || ''),
      name: String(this.anfitrion.name || ''),
      lastname: String(this.anfitrion.lastName || ''),
      email: String(this.anfitrion.email || ''),
      shift: 'Todo el dia',
      status: 'Disponible'
    };
  }

  /**
   * NUEVO: Getter para datos de imágenes
   */
  get imagenesData() {
    const imagenesSubidas = this.imagenesSubidas;

    return {
      images: imagenesSubidas.map((img, index) => ({
        url: img.url,
        key: img.key,
        name: img.file.name,
        size: img.file.size,
        type: img.file.type,
        isPrincipal: index === this.imagenPrincipalIndex,
        order: index
      })),
      principal: this.imagenPrincipalIndex >= 0 ? imagenesSubidas[this.imagenPrincipalIndex]?.url : null,
      total: imagenesSubidas.length
    };
  }

  eliminarHabitacion(index: number): void {
    // Verificar que el índice sea válido
    if (index < 0 || index >= this.habitaciones.length) {
      console.error('Índice de habitación inválido:', index);
      return;
    }

    const habitacion = this.habitaciones[index];

    // Confirmar eliminación
    const confirmacion = confirm(
      `¿Estás seguro de que quieres eliminar la habitación ${habitacion.number} (${habitacion.type})?`
    );

    if (!confirmacion) {
      return;
    }

    try {
      // Eliminar imágenes de la habitación de S3 si existen
      if (habitacion.images && habitacion.images.length > 0) {
        this.eliminarImagenesHabitacion(habitacion.images);
      }

      // Eliminar la habitación de la lista
      this.habitaciones.splice(index, 1);

      console.log(`Habitación eliminada: ${habitacion.room_id}`);

      // Opcional: Mostrar mensaje de éxito
      // alert('Habitación eliminada correctamente');

    } catch (error) {
      console.error('Error eliminando habitación:', error);
      alert('Error al eliminar la habitación. Por favor, inténtalo de nuevo.');
    }
  }

  /**
   * Método auxiliar para eliminar imágenes de una habitación de S3
   * @param imageUrls - Array de URLs de imágenes a eliminar
   */
  private async eliminarImagenesHabitacion(imageUrls: string[]): Promise<void> {
    try {
      for (const imageUrl of imageUrls) {
        // Extraer la key de la URL de S3
        const key = this.extraerKeyDeUrl(imageUrl);
        if (key) {
          await this.s3UploadService.deleteImageFromS3(key);
        }
      }
    } catch (error) {
      console.warn('Error eliminando algunas imágenes de la habitación:', error);
    }
  }

  cancelarEdicion() {
    this.router.navigate(['/allhostings']);
  }

  /**
   * Extrae la key de S3 de una URL
   * @param url - URL completa de la imagen
   * @returns La key de S3 o null si no se puede extraer
   */
  private extraerKeyDeUrl(url: string): string | null {
    try {
      // Asumiendo que las URLs tienen el formato: https://bucket.s3.amazonaws.com/room/filename
      // o https://s3.amazonaws.com/bucket/room/filename
      const urlObj = new URL(url);
      const pathname = urlObj.pathname;

      // Remover el primer slash y devolver el resto como key
      return pathname.substring(1);
    } catch (error) {
      console.error('Error extrayendo key de URL:', error);
      return null;
    }
  }




  /**
     * Método actualizado para enviar datos
     */
  enviarDatos() {
    // Validaciones
    if (!this.validarAnfitrion()) {
      alert('Por favor completa los datos del anfitrión');
      return;
    }

    if (!this.validarUbicacion()) {
      alert('Por favor completa los datos de ubicación');
      return;
    }

    if (!this.validarImagenes()) {
      alert('Por favor sube al menos una imagen del alojamiento');
      return;
    }

        //if (!this.validarHabitacion()) {
      //alert('Por favor completa los datos basicos de la habitación');
      //return;
    //}

    if (!this.validarMetodosPago()) {
      alert('Debes seleccionar al menos un método de pago.');
      return;
    }

    if (!this.validarMetodosPago()) {
      alert('Debes seleccionar al menos un método de pago.');
      return;
    }

    // Mostrar spinner de carga
    this.isLoading = true;
    this.loadingMessage = 'Procesando alojamiento...';

    // Generar IDs si no existen
    if (!this.anfitrion.anfitrion_id) {
      this.generarAnfitrionId();
    }
    if (!this.ubicacionData.location_id) {
      this.generarLocationId();
    }
    if (!this.servicioData.service_id) {
      this.generarServiceId();
    }

    const hostingData = {
      id: this.datoBasicos.id ? String(this.datoBasicos.id) : this.generarAlojamientoId(),
      name: String(this.datoBasicos.name || ''),
      title: String(this.datoBasicos.name || ''),
      type: String(this.datoBasicos.type || ''),
      description: String(this.datoBasicos.description || ''),
      ability: String(this.datoBasicos.capacity || ''),
      rooms: String(this.datoBasicos.rooms || ''),
      phone: String(this.datoBasicos.phone || ''),
      email: String(this.datoBasicos.email || ''),
      payment_method: Array.isArray(this.metodosPagoSeleccionados) ? this.metodosPagoSeleccionados.map(String) : [],
      images: Array.isArray(this.imagenesData.images) ? this.imagenesData.images.map(img => img.url) : [],
      additional: Array.isArray(this.serviciosAdicionalesExtras)
        ? this.serviciosAdicionalesExtras.map((item, idx) => ({
          additional_id: String(item.additional_id || `add-${idx + 1}`),
          service: String(item.service || ''),
          cost: Number(item.cost) || 0,
          status: String(item.status || 'activo')
        }))
        : [],
      included: Array.isArray(this.serviciosAdicionalesIncluidos)
        ? this.serviciosAdicionalesIncluidos.map(item => String(item.service || ''))
        : [],
      amphitryon: this.amphitryonData,
      location: {
        location_id: String(this.ubicacionData.location_id || ''),
        country: String(this.ubicacionData.pais || ''),
        city: String(this.ubicacionData.ciudad || ''),
        adress: String(this.ubicacionData.direccion || ''),
        area: String(this.ubicacionData.area || ''),
        latitude: String(this.ubicacionData.latitud || ''),
        longitude: String(this.ubicacionData.longitud || '')
      },
      review: {
        room_id: this.habitaciones.length > 0 ? String(this.habitaciones[0].room_id || '') : '',
        average: this.reviews.length > 0 ? (
          (this.reviews.reduce((acc, r) => acc + (Number(r.rating) || 0), 0) / this.reviews.length).toFixed(2)
        ) : '0',
        reviews: this.reviews.map((r, idx) => ({
          review_id: `review-${idx + 1}`,
          customer_id: `customer-${idx + 1}`,
          rating: Number(r.rating) || 0,
          comment: String(r.comment || ''),
          created_at: r.created_at ? String(r.created_at) : new Date().toISOString(),
          updated_at: r.created_at ? String(r.created_at) : new Date().toISOString()
        }))
      },
      room: this.habitaciones.length > 0 ? {
        room_id: String(this.habitaciones[0].room_id || ''),
        type: String(this.habitaciones[0].type || ''),
        number: String(this.habitaciones[0].number || ''),
        floor: String(this.habitaciones[0].floor || ''),
        beds: String(this.habitaciones[0].beds || ''),
        bathroom: String(this.habitaciones[0].bathroom || ''),
        price_per_night: String(this.habitaciones[0].price_per_night || ''),
        images: Array.isArray(this.habitaciones[0].images) ? this.habitaciones[0].images.map(String) : []
      } : {
        room_id: '',
        type: '',
        number: '',
        floor: '',
        beds: '',
        bathroom: '',
        price_per_night: '',
        images: []
      },
      rule: this.reglas.length > 0 ? {
        rule_id: String(this.reglas[0].rule_id || ''),
        title: String(this.reglas[0].title || ''),
        category: String(this.reglas[0].category || ''),
        description: String(this.reglas[0].description || ''),
        penalty: String(this.reglas[0].penalty || ''),
        created_at: String(this.reglas[0].created_at),
        updated_at: new Date().toISOString(),
        status: String(this.reglas[0].status || 'active')
      } : {
        rule_id: '',
        title: '',
        category: '',
        description: '',
        penalty: '',
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString(),
        status: 'active'
      },
      service: {
        service_id: String(this.servicioData.service_id || ''),
        name: Array.isArray(this.servicioData.name) ? this.servicioData.name.map(String) : [],
        accessibility: String(this.servicioData.accessibility || '')
      },
      updated_at: new Date().toISOString(),
      principal_image: this.imagenesData.principal,
      total_images: this.imagenesData.total
    };

    if (this.isEditMode && this.hostingIdToEdit) {
      this.hostingService.updateHosting(this.hostingIdToEdit, hostingData).subscribe({
        next: (resp) => {
          setTimeout(() => {
            this.isLoading = false;
            alert('¡Alojamiento actualizado exitosamente!');
            if (this.modoAdminHotel) {
              this.router.navigate(['/admin-hotel']);
            } else {
              this.router.navigate(['/allhostings']);
            }
          }, 2000);
        },
        error: (err) => {
          this.isLoading = false;
          alert('Error al actualizar alojamiento: ' + (err?.message || 'Error desconocido'));
        }
      });
    } else {
      this.hostingService.createHosting(hostingData).subscribe({
        next: async (resp) => {
          setTimeout(async () => {
            if (this.modoAdminHotel && resp && resp.id) {
              try {
                let user:any;
                 user = this.authService.getUserFromToken();
                 console.log(user)
                let userId = user.sub;
                if (!userId) {
                  this.isLoading = false;
                  alert('No se pudo obtener el email del usuario actual para asociar el alojamiento.');
                } else {
                  await this.authService.addAlojamientoIdToUser(resp.id, userId);
                  this.isLoading = false;
                  alert('¡Alojamiento creado exitosamente!');
                  await this.authService.refreshToken().catch(() => { });
                }
              } catch (e: any) {
                this.isLoading = false;
                alert('El alojamiento fue creado, pero no se pudo asignar al usuario: ' + (e?.message || e));
              }
            } else {
              this.isLoading = false;
            }
            if (this.modoAdminHotel) {
              this.router.navigate(['/admin-hotel']);
            } else {
              this.router.navigate(['/allhostings']);
            }
          }, 2000);
        },
        error: (err) => {
          this.isLoading = false;
          alert('Error al crear alojamiento: ' + (err?.message || 'Error desconocido'));
        }
      });
    }
  }
}

